
var Globalize = require('globalize/dist/globalize-runtime');
require('globalize/dist/globalize-runtime/number');
require('globalize/dist/globalize-runtime/plural');
require('globalize/dist/globalize-runtime/message');
require('globalize/dist/globalize-runtime/date');
var validateParameterTypeNumber = Globalize._validateParameterTypeNumber;
var validateParameterPresence = Globalize._validateParameterPresence;
var numberRound = Globalize._numberRound;
var numberFormat = Globalize._numberFormat;
var numberFormatterFn = Globalize._numberFormatterFn;
var validateParameterTypeString = Globalize._validateParameterTypeString;
var numberParse = Globalize._numberParse;
var numberParserFn = Globalize._numberParserFn;
var pluralGeneratorFn = Globalize._pluralGeneratorFn;
var validateParameterTypeMessageVariables = Globalize._validateParameterTypeMessageVariables;
var messageFormat = Globalize._messageFormat;
var messageFormatterFn = Globalize._messageFormatterFn;
var validateParameterTypeDate = Globalize._validateParameterTypeDate;
var dateToPartsFormat = Globalize._dateToPartsFormat;
var dateToPartsFormatterFn = Globalize._dateToPartsFormatterFn;
var dateFormat = Globalize._dateFormat;
var dateFormatterFn = Globalize._dateFormatterFn;
var dateTokenizer = Globalize._dateTokenizer;
var dateParse = Globalize._dateParse;
var dateParserFn = Globalize._dateParserFn;

Globalize.a147098952 = numberFormatterFn(["",,2,0,0,,,,,,"","00","-00","-","",numberRound(),"∞","NaN",{".":",",",":" ","%":"%","+":"+","-":"-","E":"E","‰":"‰"},]);
Globalize.b361245240 = numberFormatterFn(["",,4,0,0,,,,,,"","0000","-0000","-","",numberRound(),"∞","NaN",{".":",",",":" ","%":"%","+":"+","-":"-","E":"E","‰":"‰"},]);
Globalize.a558923788 = numberFormatterFn(["",,1,0,0,,,,,,"","0","-0","-","",numberRound(),"∞","NaN",{".":",",",":" ","%":"%","+":"+","-":"-","E":"E","‰":"‰"},]);
Globalize.a1594060179 = numberParserFn([{",":"."," ":",","%":"%","+":"+","-":"-","E":"E","‰":"‰"},,{"infinity":/^∞/,"nan":/^NaN/,"negativePrefix":/^-/,"negativeSuffix":/^/,"number":/^\d+/,"prefix":/^/,"suffix":/^/}]);
Globalize.b1189759620 = pluralGeneratorFn(function(n
) {
  var s = String(n).split('.'), v0 = !s[1];
  return (n == 1 && v0) ? 'one' : 'other';
});
Globalize.b836022089 = messageFormatterFn((function(  ) {
  return function(d) { return "Travel: Holidays, Cheap Flights, Airline Tickets & Airfares"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b67992031 = messageFormatterFn((function(  ) {
  return function(d) { return "Points applied"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b990641852 = messageFormatterFn((function(  ) {
  return function(d) { return "Points removed"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b705777144 = messageFormatterFn((function(  ) {
  return function(d) { return "Close the dialogue"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b361402549 = messageFormatterFn((function(  ) {
  return function(d) { return "Going to"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b999595505 = messageFormatterFn((function(  ) {
  return function(d) { return "Check-in"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b1347827808 = messageFormatterFn((function(  ) {
  return function(d) { return "Check-out"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a1193165197 = messageFormatterFn((function(  ) {
  return function(d) { return "Select date"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b377075639 = messageFormatterFn((function(  ) {
  return function(d) { return "Travellers"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b1701898659 = messageFormatterFn((function(  ) {
  return function(d) { return "Search"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b1757139481 = messageFormatterFn((function(  ) {
  return function(d) { return "More information about " + d["0"]; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a438143748 = messageFormatterFn((function(  ) {
  return function(d) { return "Opens " + d["0"] + " in new tab, return to original tab to proceed"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a325355999 = messageFormatterFn((function(  ) {
  return function(d) { return "Search results"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a1196469072 = messageFormatterFn((function(  ) {
  return function(d) { return "Please select a destination"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b810056554 = messageFormatterFn((function(  ) {
  return function(d) { return "Please select a valid check in date"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a326622953 = messageFormatterFn((function(  ) {
  return function(d) { return "Select dates for your trip"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a792962063 = messageFormatterFn((function(  ) {
  return function(d) { return "Check out date must be after check in date"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b1480405801 = messageFormatterFn((function(  ) {
  return function(d) { return "Check out date must be within 28 days of check in date"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a1954541349 = messageFormatterFn((function(  ) {
  return function(d) { return "Please select a valid check out date"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b1829245421 = messageFormatterFn((function(  ) {
  return function(d) { return "Please select the number of travellers"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a1629941532 = messageFormatterFn((function(  ) {
  return function(d) { return "Tell us the age of the child travelling"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b557240084 = messageFormatterFn((function(  ) {
  return function(d) { return "Tell us the age of the children travelling"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b1022524406 = messageFormatterFn((function(  ) {
  return function(d) { return "Stay dates must fall between trip dates"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b681963281 = messageFormatterFn((function(  ) {
  return function(d) { return "Select"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a1321577153 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["en-ZA"], { zero: function() { return number(d["0"]) + " rooms";}, one: function() { return number(d["0"]) + " room";}, two: function() { return number(d["0"]) + " rooms";}, few: function() { return number(d["0"]) + " rooms";}, many: function() { return number(d["0"]) + " rooms";}, other: function() { return number(d["0"]) + " rooms";} }) + ", " + plural(d["1"], 0, pluralFuncs["en-ZA"], { zero: function() { return number(d["1"]) + " travelers";}, one: function() { return number(d["1"]) + " traveller";}, two: function() { return number(d["1"]) + " travellers";}, few: function() { return number(d["1"]) + " travellers";}, many: function() { return number(d["1"]) + " travellers";}, other: function() { return number(d["1"]) + " travellers";} }); }
})(messageFormat.number, messageFormat.plural, {"en-ZA": Globalize("en-ZA").pluralGenerator()}), Globalize("en-ZA").pluralGenerator({}));
Globalize.b901340017 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["1"], 0, pluralFuncs["en-ZA"], { zero: function() { return number(d["1"]) + " travelers";}, one: function() { return number(d["1"]) + " traveller";}, two: function() { return number(d["1"]) + " travellers";}, few: function() { return number(d["1"]) + " travellers";}, many: function() { return number(d["1"]) + " travellers";}, other: function() { return number(d["1"]) + " travellers";} }); }
})(messageFormat.number, messageFormat.plural, {"en-ZA": Globalize("en-ZA").pluralGenerator()}), Globalize("en-ZA").pluralGenerator({}));
Globalize.b1643036625 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["1"], 0, pluralFuncs["en-ZA"], { zero: function() { return number(d["1"]) + " travelers";}, one: function() { return number(d["1"]) + " traveller";}, two: function() { return number(d["1"]) + " travellers";}, few: function() { return number(d["1"]) + " travellers";}, many: function() { return number(d["1"]) + " travellers";}, other: function() { return number(d["1"]) + " travellers";} }) + ", pets"; }
})(messageFormat.number, messageFormat.plural, {"en-ZA": Globalize("en-ZA").pluralGenerator()}), Globalize("en-ZA").pluralGenerator({}));
Globalize.b571980850 = messageFormatterFn((function(  ) {
  return function(d) { return "Travellers"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b1470960834 = messageFormatterFn((function(  ) {
  return function(d) { return "Room " + d["0"] + " added. Edit guest information below."; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b1480880162 = messageFormatterFn((function(  ) {
  return function(d) { return "Room removed. Edit room " + d["0"] + " guest information below."; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b1147581766 = messageFormatterFn((function(  ) {
  return function(d) { return "Cancel, close the Traveller Selector without saving changes. Or, edit the guest information below."; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a1349890554 = messageFormatterFn((function(  ) {
  return function(d) { return "Done"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a839738114 = messageFormatterFn((function(  ) {
  return function(d) { return "Save changes and close the Traveller Selector."; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b223978582 = messageFormatterFn((function(  ) {
  return function(d) { return "Add another room"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b1467389065 = messageFormatterFn((function(  ) {
  return function(d) { return "Remove room"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a2122192383 = messageFormatterFn((function(  ) {
  return function(d) { return "Remove room " + d["0"] + " of " + d["1"]; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a524395139 = messageFormatterFn((function(  ) {
  return function(d) { return "Child " + d["0"] + " age"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a1066125477 = messageFormatterFn((function(  ) {
  return function(d) { return "Room " + d["0"]; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b946475260 = messageFormatterFn((function(  ) {
  return function(d) { return "Room " + d["0"] + " of " + d["1"]; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a217804282 = messageFormatterFn((function(  ) {
  return function(d) { return "Child " + d["0"] + ", age " + d["1"] + " updated."; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b1920475360 = messageFormatterFn((function(  ) {
  return function(d) { return "Under 1"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b385796814 = messageFormatterFn((function(  ) {
  return function(d) { return "Children"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b398602793 = messageFormatterFn((function(  ) {
  return function(d) { return "(Age 0-17)"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b694071592 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["en-ZA"], { zero: function() { return number(d["0"]) + " Adults";}, one: function() { return number(d["0"]) + " Adult";}, two: function() { return number(d["0"]) + " Adults";}, few: function() { return number(d["0"]) + " Adults";}, many: function() { return number(d["0"]) + " Adults";}, other: function() { return number(d["0"]) + " Adults";} }); }
})(messageFormat.number, messageFormat.plural, {"en-ZA": Globalize("en-ZA").pluralGenerator()}), Globalize("en-ZA").pluralGenerator({}));
Globalize.b211643298 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["en-ZA"], { zero: function() { return number(d["0"]) + " Children";}, one: function() { return number(d["0"]) + " Child";}, two: function() { return number(d["0"]) + " Children";}, few: function() { return number(d["0"]) + " Children";}, many: function() { return number(d["0"]) + " Children";}, other: function() { return number(d["0"]) + " Children";} }); }
})(messageFormat.number, messageFormat.plural, {"en-ZA": Globalize("en-ZA").pluralGenerator()}), Globalize("en-ZA").pluralGenerator({}));
Globalize.a18297528 = messageFormatterFn((function(  ) {
  return function(d) { return "Adults"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a1296771508 = messageFormatterFn((function(  ) {
  return function(d) { return "Decrease children in room " + d["0"]; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b654811206 = messageFormatterFn((function(  ) {
  return function(d) { return "Decrease adults in room " + d["0"]; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a2062989200 = messageFormatterFn((function(  ) {
  return function(d) { return "Increase children in room " + d["0"]; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a1017492630 = messageFormatterFn((function(  ) {
  return function(d) { return "Increase adults in room " + d["0"]; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b1639755266 = messageFormatterFn((function(  ) {
  return function(d) { return "Pets"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b395708518 = messageFormatterFn((function(  ) {
  return function(d) { return "Pets included?"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a1088524686 = messageFormatterFn((function(  ) {
  return function(d) { return "Yes"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b23357888 = messageFormatterFn((function(  ) {
  return function(d) { return "No"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a653374858 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " has been added to your lists"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a726295996 = messageFormatterFn((function(  ) {
  return function(d) { return "Opens in a new window"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b678020697 = messageFormatterFn((function(  ) {
  return function(d) { return "Guest reviews"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b291724799 = messageFormatterFn((function(  ) {
  return function(d) { return "Cancel, go back to hotel details."; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b715021577 = messageFormatterFn((function(  ) {
  return function(d) { return "Check availability"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b888335070 = messageFormatterFn((function(  ) {
  return function(d) { return "Check prices"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b11391248 = messageFormatterFn((function(  ) {
  return function(d) { return "Change Search"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b250269331 = messageFormatterFn((function(  ) {
  return function(d) { return "Select a later check in date"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a804164041 = messageFormatterFn((function(  ) {
  return function(d) { return "Select an earlier check in date"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a1286836242 = messageFormatterFn((function(  ) {
  return function(d) { return "Select a later check out date"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b1953697682 = messageFormatterFn((function(  ) {
  return function(d) { return "Select an earlier check out date"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a2030724184 = messageFormatterFn((function(  ) {
  return function(d) { return "Price was " + d["0"]; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b580812906 = messageFormatterFn((function(  ) {
  return function(d) { return "Price is " + d["0"]; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a258887355 = messageFormatterFn((function(  ) {
  return function(d) { return "Price is now " + d["0"]; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b614189495 = messageFormatterFn((function(  ) {
  return function(d) { return "Price was " + d["0"] + ", price is now " + d["1"]; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b1108779010 = messageFormatterFn((function(  ) {
  return function(d) { return "per night"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b1829212558 = messageFormatterFn((function(  ) {
  return function(d) { return "Cancel, go back to hotel details."; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b1019684790 = messageFormatterFn((function(  ) {
  return function(d) { return "More details"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a1812027732 = messageFormatterFn((function(  ) {
  return function(d) { return "Close, go back to hotel details."; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b61970818 = messageFormatterFn((function(  ) {
  return function(d) { return "Something went wrong."; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b1888256584 = messageFormatterFn((function(  ) {
  return function(d) { return "Try a new search."; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b745016595 = messageFormatterFn((function(  ) {
  return function(d) { return "You may also like"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b1415213280 = messageFormatterFn((function(  ) {
  return function(d) { return "Close Filters"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b669924440 = messageFormatterFn((function(  ) {
  return function(d) { return "Sort & filter"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b1433359050 = messageFormatterFn((function(  ) {
  return function(d) { return "Done"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a954576565 = messageFormatterFn((function(  ) {
  return function(d) { return "Clear"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a1773102412 = messageFormatterFn((function(  ) {
  return function(d) { return "Click apply or navigate back to close filters"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b1592465458 = messageFormatterFn((function(  ) {
  return function(d) { return "Minimum price"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a1823344224 = messageFormatterFn((function(  ) {
  return function(d) { return "Maximum price"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b2009379813 = messageFormatterFn((function(  ) {
  return function(d) { return "Star Rating"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b1626486678 = messageFormatterFn((function(  ) {
  return function(d) { return "Sort by"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a1243257461 = messageFormatterFn((function(  ) {
  return function(d) { return "Filter by"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b1957061323 = messageFormatterFn((function(  ) {
  return function(d) { return "Back to hotel search"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a1542952747 = messageFormatterFn((function(  ) {
  return function(d) { return "Searching thousands of properties"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b1776657446 = messageFormatterFn((function(  ) {
  return function(d) { return "Searching for thousands of package deals"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b1873644006 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["en-ZA"], { zero: function() { return number(d["0"]) + " filters";}, one: function() { return number(d["0"]) + " filter";}, two: function() { return number(d["0"]) + " filters";}, few: function() { return number(d["0"]) + " filters";}, many: function() { return number(d["0"]) + " filters";}, other: function() { return number(d["0"]) + " filters";} }) + " applied"; }
})(messageFormat.number, messageFormat.plural, {"en-ZA": Globalize("en-ZA").pluralGenerator()}), Globalize("en-ZA").pluralGenerator({}));
Globalize.b76024550 = messageFormatterFn((function(  ) {
  return function(d) { return "Sort & filter"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b343507854 = messageFormatterFn((function(  ) {
  return function(d) { return "Filter"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a365110203 = messageFormatterFn((function(  ) {
  return function(d) { return "View in a map"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b849409064 = messageFormatterFn((function(  ) {
  return function(d) { return "results are loading"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b634896775 = messageFormatterFn((function(  ) {
  return function(d) { return "results updated"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b1543829047 = messageFormatterFn((function(  ) {
  return function(d) { return "error retrieving results"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a1469180917 = messageFormatterFn((function(  ) {
  return function(d) { return "results are empty"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a1330362739 = messageFormatterFn((function(  ) {
  return function(d) { return "Search hotels"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a679538302 = messageFormatterFn((function(  ) {
  return function(d) { return "Close"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a145355091 = messageFormatterFn((function(  ) {
  return function(d) { return "Try these dates instead"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a7720019 = messageFormatterFn((function(  ) {
  return function(d) { return "Show more dates"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b30101097 = messageFormatterFn((function(  ) {
  return function(d) { return "Show less dates"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b1893832808 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " Hotel Search results"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a231831285 = messageFormatterFn((function(  ) {
  return function(d) { return "Invalid Hotel Search results"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b1309952691 = messageFormatterFn((function(  ) {
  return function(d) { return "Show more"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b470795603 = messageFormatterFn((function(  ) {
  return function(d) { return "Sorry, we couldn’t find any results. Try adjusting your search."; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a1508334921 = messageFormatterFn((function(  ) {
  return function(d) { return "Selected filter"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b439592725 = messageFormatterFn((function(  ) {
  return function(d) { return "Selected filters"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b327068437 = messageFormatterFn((function(  ) {
  return function(d) { return "Destination missing"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b2082430217 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " - " + d["1"]; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b773659241 = messageFormatterFn((function(  ) {
  return function(d) { return "Remove all filters"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b506847786 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["en-ZA"], { zero: function() { return number(d["0"]) + " travelers";}, one: function() { return number(d["0"]) + " traveller";}, two: function() { return number(d["0"]) + " travellers";}, few: function() { return number(d["0"]) + " travellers";}, many: function() { return number(d["0"]) + " travellers";}, other: function() { return number(d["0"]) + " travellers";} }); }
})(messageFormat.number, messageFormat.plural, {"en-ZA": Globalize("en-ZA").pluralGenerator()}), Globalize("en-ZA").pluralGenerator({}));
Globalize.b2022029202 = messageFormatterFn((function(  ) {
  return function(d) { return "Sorry, we're having a problem on our end"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b1743072315 = messageFormatterFn((function(  ) {
  return function(d) { return "Try again"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a715531603 = messageFormatterFn((function(  ) {
  return function(d) { return "Save " + d["0"] + " to your lists"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a226640073 = messageFormatterFn((function(  ) {
  return function(d) { return "Remove " + d["0"] + " from your lists"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b1637251697 = messageFormatterFn((function(  ) {
  return function(d) { return "Details for your next stay"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b893884280 = messageFormatterFn((function(  ) {
  return function(d) { return "Search this area"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a789531818 = messageFormatterFn((function(  ) {
  return function(d) { return "Sorry, something went wrong. Please try your search again."; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a1429274179 = messageFormatterFn((function(  ) {
  return function(d) { return "Close Map"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a545293051 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["en-ZA"], { zero: function() { return number(d["0"]) + " properties";}, one: function() { return number(d["0"]) + " property";}, two: function() { return number(d["0"]) + " properties";}, few: function() { return number(d["0"]) + " properties";}, many: function() { return number(d["0"]) + " properties";}, other: function() { return number(d["0"]) + " properties";} }) + "\nfrom " + d["1"]; }
})(messageFormat.number, messageFormat.plural, {"en-ZA": Globalize("en-ZA").pluralGenerator()}), Globalize("en-ZA").pluralGenerator({}));
Globalize.b1273035684 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["en-ZA"], { zero: function() { return number(d["0"]) + " properties";}, one: function() { return number(d["0"]) + " property";}, two: function() { return number(d["0"]) + " properties";}, few: function() { return number(d["0"]) + " properties";}, many: function() { return number(d["0"]) + " properties";}, other: function() { return number(d["0"]) + " properties";} }); }
})(messageFormat.number, messageFormat.plural, {"en-ZA": Globalize("en-ZA").pluralGenerator()}), Globalize("en-ZA").pluralGenerator({}));
Globalize.a824080075 = messageFormatterFn((function(  ) {
  return function(d) { return "See more"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b399782690 = messageFormatterFn((function(  ) {
  return function(d) { return "See less"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a1569683444 = messageFormatterFn((function(  ) {
  return function(d) { return "Apologies, something went wrong on our end"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a689559360 = messageFormatterFn((function(  ) {
  return function(d) { return "Next Item"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b383120188 = messageFormatterFn((function(  ) {
  return function(d) { return "Previous Item"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b1652174617 = messageFormatterFn((function(  ) {
  return function(d) { return "Check out"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a2053203208 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Your trip (" + plural(d["0"], 0, pluralFuncs["en-ZA"], { zero: function() { return number(d["0"]) + " rooms";}, one: function() { return number(d["0"]) + " room";}, two: function() { return number(d["0"]) + " rooms";}, few: function() { return number(d["0"]) + " rooms";}, many: function() { return number(d["0"]) + " rooms";}, other: function() { return number(d["0"]) + " rooms";} }) + ")"; }
})(messageFormat.number, messageFormat.plural, {"en-ZA": Globalize("en-ZA").pluralGenerator()}), Globalize("en-ZA").pluralGenerator({}));
Globalize.b1673880369 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Your trip (" + plural(d["0"], 0, pluralFuncs["en-ZA"], { zero: function() { return number(d["0"]) + " stays";}, one: function() { return number(d["0"]) + " stay";}, two: function() { return number(d["0"]) + " stays";}, few: function() { return number(d["0"]) + " stays";}, many: function() { return number(d["0"]) + " stays";}, other: function() { return number(d["0"]) + " stays";} }) + ")"; }
})(messageFormat.number, messageFormat.plural, {"en-ZA": Globalize("en-ZA").pluralGenerator()}), Globalize("en-ZA").pluralGenerator({}));
Globalize.b1508802611 = messageFormatterFn((function(  ) {
  return function(d) { return "Select your next room"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a1353824746 = messageFormatterFn((function(  ) {
  return function(d) { return "No longer available"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b506003254 = messageFormatterFn((function(  ) {
  return function(d) { return "Some properties in your trip are no longer available. Check out anyway?"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b919890671 = messageFormatterFn((function(  ) {
  return function(d) { return "per room"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a124377767 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["en-ZA"], { zero: function() { return number(d["0"]) + " guests";}, one: function() { return number(d["0"]) + " guest";}, two: function() { return number(d["0"]) + " guests";}, few: function() { return number(d["0"]) + " guests";}, many: function() { return number(d["0"]) + " guests";}, other: function() { return number(d["0"]) + " guests";} }); }
})(messageFormat.number, messageFormat.plural, {"en-ZA": Globalize("en-ZA").pluralGenerator()}), Globalize("en-ZA").pluralGenerator({}));
Globalize.b520357571 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["en-ZA"], { zero: function() { return number(d["0"]) + " rooms";}, one: function() { return number(d["0"]) + " room";}, two: function() { return number(d["0"]) + " rooms";}, few: function() { return number(d["0"]) + " rooms";}, many: function() { return number(d["0"]) + " rooms";}, other: function() { return number(d["0"]) + " rooms";} }) + ", " + plural(d["1"], 0, pluralFuncs["en-ZA"], { zero: function() { return number(d["1"]) + " guests";}, one: function() { return number(d["1"]) + " guest";}, two: function() { return number(d["1"]) + " guests";}, few: function() { return number(d["1"]) + " guests";}, many: function() { return number(d["1"]) + " guests";}, other: function() { return number(d["1"]) + " guests";} }); }
})(messageFormat.number, messageFormat.plural, {"en-ZA": Globalize("en-ZA").pluralGenerator()}), Globalize("en-ZA").pluralGenerator({}));
Globalize.a1603970378 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + "/night"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a219751598 = messageFormatterFn((function(  ) {
  return function(d) { return "Change room"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b1722927866 = messageFormatterFn((function(  ) {
  return function(d) { return "Code copied to clipboard."; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a1501147871 = messageFormatterFn((function(  ) {
  return function(d) { return "Sorry, we're having a problem on our end"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a112446112 = messageFormatterFn((function(  ) {
  return function(d) { return "Please try your search again"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b663051894 = messageFormatterFn((function(  ) {
  return function(d) { return "Retry"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b1205118391 = messageFormatterFn((function(  ) {
  return function(d) { return "Car hire pick-up and drop-off"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b1514177682 = messageFormatterFn((function(  ) {
  return function(d) { return "Pick-up time"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b181252162 = messageFormatterFn((function(  ) {
  return function(d) { return "Drop-off time"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a1176572253 = messageFormatterFn((function(  ) {
  return function(d) { return "Car hire"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b163659958 = messageFormatterFn((function(  ) {
  return function(d) { return "The drop-off time must occur at least 2 hours after the pick-up time"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b1571478410 = messageFormatterFn((function(  ) {
  return function(d) { return "00:00"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b1571389037 = messageFormatterFn((function(  ) {
  return function(d) { return "00:30"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b1570554889 = messageFormatterFn((function(  ) {
  return function(d) { return "01:00"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b1570465516 = messageFormatterFn((function(  ) {
  return function(d) { return "01:30"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b1569631368 = messageFormatterFn((function(  ) {
  return function(d) { return "02:00"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b1569541995 = messageFormatterFn((function(  ) {
  return function(d) { return "02:30"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b1568707847 = messageFormatterFn((function(  ) {
  return function(d) { return "03:00"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b1568618474 = messageFormatterFn((function(  ) {
  return function(d) { return "03:30"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b1567784326 = messageFormatterFn((function(  ) {
  return function(d) { return "04:00"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b1567694953 = messageFormatterFn((function(  ) {
  return function(d) { return "04:30"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b1566860805 = messageFormatterFn((function(  ) {
  return function(d) { return "05:00"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b1566771432 = messageFormatterFn((function(  ) {
  return function(d) { return "05:30"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b1565937284 = messageFormatterFn((function(  ) {
  return function(d) { return "06:00"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b1565847911 = messageFormatterFn((function(  ) {
  return function(d) { return "06:30"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b1565013763 = messageFormatterFn((function(  ) {
  return function(d) { return "07:00"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b1564924390 = messageFormatterFn((function(  ) {
  return function(d) { return "07:30"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b1564090242 = messageFormatterFn((function(  ) {
  return function(d) { return "08:00"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b1564000869 = messageFormatterFn((function(  ) {
  return function(d) { return "08:30"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b1563166721 = messageFormatterFn((function(  ) {
  return function(d) { return "09:00"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b1563077348 = messageFormatterFn((function(  ) {
  return function(d) { return "09:30"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b1542849259 = messageFormatterFn((function(  ) {
  return function(d) { return "10:00"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b1542759886 = messageFormatterFn((function(  ) {
  return function(d) { return "10:30"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b1541925738 = messageFormatterFn((function(  ) {
  return function(d) { return "11:00"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b1541836365 = messageFormatterFn((function(  ) {
  return function(d) { return "11:30"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b1541002217 = messageFormatterFn((function(  ) {
  return function(d) { return "12:00"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b1540912844 = messageFormatterFn((function(  ) {
  return function(d) { return "12:30"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b1540078696 = messageFormatterFn((function(  ) {
  return function(d) { return "13:00"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b1539989323 = messageFormatterFn((function(  ) {
  return function(d) { return "13:30"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b1539155175 = messageFormatterFn((function(  ) {
  return function(d) { return "14:00"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b1539065802 = messageFormatterFn((function(  ) {
  return function(d) { return "14:30"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b1538231654 = messageFormatterFn((function(  ) {
  return function(d) { return "15:00"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b1538142281 = messageFormatterFn((function(  ) {
  return function(d) { return "15:30"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b1537308133 = messageFormatterFn((function(  ) {
  return function(d) { return "16:00"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b1537218760 = messageFormatterFn((function(  ) {
  return function(d) { return "16:30"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b1536384612 = messageFormatterFn((function(  ) {
  return function(d) { return "17:00"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b1536295239 = messageFormatterFn((function(  ) {
  return function(d) { return "17:30"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b1535461091 = messageFormatterFn((function(  ) {
  return function(d) { return "18:00"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b1535371718 = messageFormatterFn((function(  ) {
  return function(d) { return "18:30"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b1534537570 = messageFormatterFn((function(  ) {
  return function(d) { return "19:00"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b1534448197 = messageFormatterFn((function(  ) {
  return function(d) { return "19:30"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b1514220108 = messageFormatterFn((function(  ) {
  return function(d) { return "20:00"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b1514130735 = messageFormatterFn((function(  ) {
  return function(d) { return "20:30"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b1513296587 = messageFormatterFn((function(  ) {
  return function(d) { return "21:00"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b1513207214 = messageFormatterFn((function(  ) {
  return function(d) { return "21:30"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b1512373066 = messageFormatterFn((function(  ) {
  return function(d) { return "22:00"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b1512283693 = messageFormatterFn((function(  ) {
  return function(d) { return "22:30"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b1511449545 = messageFormatterFn((function(  ) {
  return function(d) { return "23:00"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b1511360172 = messageFormatterFn((function(  ) {
  return function(d) { return "23:30"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a403513015 = messageFormatterFn((function(  ) {
  return function(d) { return "Direct flights only"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a2122951734 = messageFormatterFn((function(  ) {
  return function(d) { return "Preferred class"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a1903730034 = messageFormatterFn((function(  ) {
  return function(d) { return "Economy"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a1876930901 = messageFormatterFn((function(  ) {
  return function(d) { return "Premium economy"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b224956946 = messageFormatterFn((function(  ) {
  return function(d) { return "Business"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b1020517482 = messageFormatterFn((function(  ) {
  return function(d) { return "First class"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b1262531475 = messageFormatterFn((function(  ) {
  return function(d) { return "Travellers"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a767134261 = messageFormatterFn((function(  ) {
  return function(d) { return "There must be at least 1 traveller (age 6+) for each infant in a lap."; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b528375440 = messageFormatterFn((function(  ) {
  return function(d) { return "Infants"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a701406457 = messageFormatterFn((function(  ) {
  return function(d) { return "(Age 2-17)"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b235794215 = messageFormatterFn((function(  ) {
  return function(d) { return "Age under 2"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b462485031 = messageFormatterFn((function(  ) {
  return function(d) { return "Infant " + d["0"] + " age"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b268481821 = messageFormatterFn((function(  ) {
  return function(d) { return "Decrease infants in room " + d["0"]; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a1903259071 = messageFormatterFn((function(  ) {
  return function(d) { return "Increase infants in room " + d["0"]; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a1144669009 = messageFormatterFn((function(  ) {
  return function(d) { return "Children under age 2 must sit in a seat or on a lap"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a999436857 = messageFormatterFn((function(  ) {
  return function(d) { return "On lap"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a369462793 = messageFormatterFn((function(  ) {
  return function(d) { return "In seat"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a2007006774 = messageFormatterFn((function(  ) {
  return function(d) { return "Airline age rules"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a57288702 = messageFormatterFn((function(  ) {
  return function(d) { return "Leaving from"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a796716038 = messageFormatterFn((function(  ) {
  return function(d) { return "Departing"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a835618370 = messageFormatterFn((function(  ) {
  return function(d) { return "Returning"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b1823945120 = messageFormatterFn((function(  ) {
  return function(d) { return "Please select an origin"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b1486197370 = messageFormatterFn((function(  ) {
  return function(d) { return "I only need accommodation for part of my trip"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a184570309 = messageFormatterFn((function(  ) {
  return function(d) { return "Sorry, something went wrong on our end. Please try again."; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a765523183 = messageFormatterFn((function(  ) {
  return function(d) { return "Select at least 1 more property to compare"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a1544681076 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return d["0"] + "/" + plural(d["1"], 0, pluralFuncs["en-ZA"], { zero: function() { return number(d["1"]) + " properties";}, one: function() { return number(d["1"]) + " property";}, two: function() { return number(d["1"]) + " properties";}, few: function() { return number(d["1"]) + " properties";}, many: function() { return number(d["1"]) + " properties";}, other: function() { return number(d["1"]) + " properties";} }) + " selected"; }
})(messageFormat.number, messageFormat.plural, {"en-ZA": Globalize("en-ZA").pluralGenerator()}), Globalize("en-ZA").pluralGenerator({}));
Globalize.b1726829528 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return d["0"] + " out of " + plural(d["1"], 0, pluralFuncs["en-ZA"], { zero: function() { return number(d["1"]) + " properties";}, one: function() { return number(d["1"]) + " property";}, two: function() { return number(d["1"]) + " properties";}, few: function() { return number(d["1"]) + " properties";}, many: function() { return number(d["1"]) + " properties";}, other: function() { return number(d["1"]) + " properties";} }) + " selected for comparison"; }
})(messageFormat.number, messageFormat.plural, {"en-ZA": Globalize("en-ZA").pluralGenerator()}), Globalize("en-ZA").pluralGenerator({}));
Globalize.a625088694 = messageFormatterFn((function(  ) {
  return function(d) { return "Compare"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b2092457178 = messageFormatterFn((function(  ) {
  return function(d) { return "Compare selected properties"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b352264256 = messageFormatterFn((function(  ) {
  return function(d) { return "Compare"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a1237168732 = messageFormatterFn((function(  ) {
  return function(d) { return "Compare selected properties"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a838157262 = messageFormatterFn((function(  ) {
  return function(d) { return "View"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b137648370 = messageFormatterFn((function(  ) {
  return function(d) { return "Click to view the property"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a603079277 = messageFormatterFn((function(  ) {
  return function(d) { return "Remove"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a1636824015 = messageFormatterFn((function(  ) {
  return function(d) { return "Click to remove the property from comparison"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a1093333060 = messageFormatterFn((function(  ) {
  return function(d) { return "Close"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b1682355516 = messageFormatterFn((function(  ) {
  return function(d) { return "Cancel"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b930465770 = messageFormatterFn((function(  ) {
  return function(d) { return "Dismiss"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b349018740 = messageFormatterFn((function(  ) {
  return function(d) { return "Done"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b2072004018 = messageFormatterFn((function(  ) {
  return function(d) { return "Remove"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b1083559195 = messageFormatterFn((function(  ) {
  return function(d) { return "selected"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a308707912 = messageFormatterFn((function(  ) {
  return function(d) { return "Loading"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a1083574105 = messageFormatterFn((function(  ) {
  return function(d) { return "Clear"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a2022789869 = messageFormatterFn((function(  ) {
  return function(d) { return "Opens in a new window"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a1749409645 = messageFormatterFn((function(  ) {
  return function(d) { return "See more"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b350621446 = messageFormatterFn((function(  ) {
  return function(d) { return "See less"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b2036731606 = messageFormatterFn((function(  ) {
  return function(d) { return "See more"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b995063945 = messageFormatterFn((function(  ) {
  return function(d) { return "See less"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a158488788 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " selected. Now choose a check out date."; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b450223555 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " selected. Now choose " + d["1"] + " to save these dates and close the datepicker."; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b548165471 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + ", selected. Current check in date."; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a928765984 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + ", selected. Current check out date."; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a1542771062 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + ", date disabled"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a942888499 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + ", current month"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b1332260078 = messageFormatterFn((function(  ) {
  return function(d) { return "Now showing " + d["0"] + " " + d["1"]; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b442720554 = messageFormatterFn((function(  ) {
  return function(d) { return "Date picker opened. Select a date from the tables below."; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b524755848 = messageFormatterFn((function(  ) {
  return function(d) { return "Cancel, close the date picker without saving changes. Or, select a date from the tables below."; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a865468248 = messageFormatterFn((function(  ) {
  return function(d) { return "Clear selected dates."; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a1338498675 = messageFormatterFn((function(  ) {
  return function(d) { return "Save changes and close the date picker."; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b999447220 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["en-ZA"], { zero: function() { return number(d["0"]) + " nights";}, one: function() { return number(d["0"]) + " night";}, two: function() { return number(d["0"]) + " nights";}, few: function() { return number(d["0"]) + " nights";}, many: function() { return number(d["0"]) + " nights";}, other: function() { return number(d["0"]) + " nights";} }); }
})(messageFormat.number, messageFormat.plural, {"en-ZA": Globalize("en-ZA").pluralGenerator()}), Globalize("en-ZA").pluralGenerator({}));
Globalize.b413709284 = messageFormatterFn((function(  ) {
  return function(d) { return "Check in"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b617873875 = messageFormatterFn((function(  ) {
  return function(d) { return "Check out"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a888797426 = messageFormatterFn((function(  ) {
  return function(d) { return "Clear dates"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b288657907 = messageFormatterFn((function(  ) {
  return function(d) { return "Done"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a152800627 = messageFormatterFn((function(  ) {
  return function(d) { return "Search"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a1456031209 = messageFormatterFn((function(  ) {
  return function(d) { return "Edit the check in date in the tables below."; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b1706969606 = messageFormatterFn((function(  ) {
  return function(d) { return "Edit the check out date in the tables below."; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b1701722825 = messageFormatterFn((function(  ) {
  return function(d) { return "selected."; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a1360330134 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " selected. Close the date picker or proceed to change the selected date."; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a1895003678 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " to " + d["1"] + " selected. Close the date picker or proceed to change the selected dates."; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a974862820 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " selected. " + d["1"] + ". Close the date picker or proceed to change the selected date."; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a828102380 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " to " + d["1"] + " selected. " + d["2"] + ". Close the date picker or proceed to change the selected dates."; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b1655630085 = messageFormatterFn((function(  ) {
  return function(d) { return "Select check-in date"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b739142156 = messageFormatterFn((function(  ) {
  return function(d) { return "Select check-out date"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b1687618973 = messageFormatterFn((function(  ) {
  return function(d) { return "blank"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a953776257 = messageFormatterFn((function(  ) {
  return function(d) { return "Previous month"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b340721819 = messageFormatterFn((function(  ) {
  return function(d) { return "Next month"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a1911656842 = messageFormatterFn((function(  ) {
  return function(d) { return "Skip to " + d["0"] + " button"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a2108477666 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " through " + d["1"]; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a246407643 = messageFormatterFn((function(  ) {
  return function(d) { return "Dates have been cleared"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a876600946 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "there " + plural(d["0"], 0, pluralFuncs["en-ZA"], { zero: function() { return "are " + number(d["0"]) + " results";}, one: function() { return "is " + number(d["0"]) + " result";}, two: function() { return "are " + number(d["0"]) + " results";}, few: function() { return "are " + number(d["0"]) + " results";}, many: function() { return "are " + number(d["0"]) + " results";}, other: function() { return "are " + number(d["0"]) + " results";} }); }
})(messageFormat.number, messageFormat.plural, {"en-ZA": Globalize("en-ZA").pluralGenerator()}), Globalize("en-ZA").pluralGenerator({}));
Globalize.b123307323 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "“" + d["0"] + "” " + plural(d["1"], 0, pluralFuncs["en-ZA"], { zero: function() { return number(d["1"]) + " results are";}, one: function() { return number(d["1"]) + " result is";}, two: function() { return number(d["1"]) + " results are";}, few: function() { return number(d["1"]) + " results are";}, many: function() { return number(d["1"]) + " results are";}, other: function() { return number(d["1"]) + " results are";} }) + " available. Use the arrow keys or swipe to navigate the list."; }
})(messageFormat.number, messageFormat.plural, {"en-ZA": Globalize("en-ZA").pluralGenerator()}), Globalize("en-ZA").pluralGenerator({}));
Globalize.b1860814225 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " search open, enter search term."; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a912654048 = messageFormatterFn((function(  ) {
  return function(d) { return "You selected " + d["0"] + "."; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b533649859 = messageFormatterFn((function(  ) {
  return function(d) { return "The menu is closed."; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b945904125 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return d["0"] + " search open, currently showing " + plural(d["1"], 0, pluralFuncs["en-ZA"], { zero: function() { return number(d["1"]) + " suggestions";}, one: function() { return number(d["1"]) + " suggestion";}, two: function() { return number(d["1"]) + " suggestions";}, few: function() { return number(d["1"]) + " suggestions";}, many: function() { return number(d["1"]) + " suggestions";}, other: function() { return number(d["1"]) + " suggestions";} }) + " for " + d["2"] + ". Navigate to list below."; }
})(messageFormat.number, messageFormat.plural, {"en-ZA": Globalize("en-ZA").pluralGenerator()}), Globalize("en-ZA").pluralGenerator({}));
Globalize.b178027564 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return d["0"] + " search open, showing " + plural(d["1"], 0, pluralFuncs["en-ZA"], { zero: function() { return number(d["1"]) + " suggestions";}, one: function() { return number(d["1"]) + " suggestion";}, two: function() { return number(d["1"]) + " suggestions";}, few: function() { return number(d["1"]) + " suggestions";}, many: function() { return number(d["1"]) + " suggestions";}, other: function() { return number(d["1"]) + " suggestions";} }) + ". Enter search term or navigate to list below."; }
})(messageFormat.number, messageFormat.plural, {"en-ZA": Globalize("en-ZA").pluralGenerator()}), Globalize("en-ZA").pluralGenerator({}));
Globalize.a1065282224 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return d["0"] + " search open, currently selected " + d["1"] + " showing " + plural(d["2"], 0, pluralFuncs["en-ZA"], { zero: function() { return number(d["2"]) + " suggestions";}, one: function() { return number(d["2"]) + " suggestion";}, two: function() { return number(d["2"]) + " suggestions";}, few: function() { return number(d["2"]) + " suggestions";}, many: function() { return number(d["2"]) + " suggestions";}, other: function() { return number(d["2"]) + " suggestions";} }) + " for " + d["3"] + ". Navigate to list below."; }
})(messageFormat.number, messageFormat.plural, {"en-ZA": Globalize("en-ZA").pluralGenerator()}), Globalize("en-ZA").pluralGenerator({}));
Globalize.b988460490 = messageFormatterFn((function(  ) {
  return function(d) { return "Done"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a1818416723 = messageFormatterFn((function(  ) {
  return function(d) { return "Clear All"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b1396043392 = messageFormatterFn((function(  ) {
  return function(d) { return "Selected Items"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a1630702029 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " removed."; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b1647241428 = messageFormatterFn((function(  ) {
  return function(d) { return "All selections removed."; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a1992977605 = messageFormatterFn((function(  ) {
  return function(d) { return "You have entered into input text field. Please search or select from suggested categories below."; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a1666383782 = messageFormatterFn((function(  ) {
  return function(d) { return "Search for “" + d["0"] + "”"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b1992699931 = messageFormatterFn((function(  ) {
  return function(d) { return "No results for “" + d["0"] + "”"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b440664709 = messageFormatterFn((function(  ) {
  return function(d) { return "Airport"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a1661338980 = messageFormatterFn((function(  ) {
  return function(d) { return "Hotel"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a1671672250 = messageFormatterFn((function(  ) {
  return function(d) { return "Point of interest"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a1528802845 = messageFormatterFn((function(  ) {
  return function(d) { return "Nearby"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a1778885728 = messageFormatterFn((function(  ) {
  return function(d) { return "Try “" + d["0"] + "”"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b1599742715 = messageFormatterFn((function(  ) {
  return function(d) { return "Region/City"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a675982407 = messageFormatterFn((function(  ) {
  return function(d) { return "Airport"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a2094657729 = messageFormatterFn((function(  ) {
  return function(d) { return "Attraction"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b2033584336 = messageFormatterFn((function(  ) {
  return function(d) { return "Hotel"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a1059767600 = messageFormatterFn((function(  ) {
  return function(d) { return "Address"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a1258167910 = messageFormatterFn((function(  ) {
  return function(d) { return "Train Station"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b1010219403 = messageFormatterFn((function(  ) {
  return function(d) { return "Metro Station"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b1861911207 = messageFormatterFn((function(  ) {
  return function(d) { return "Explore nearby places"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a1910728144 = messageFormatterFn((function(  ) {
  return function(d) { return "Recent searches"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a1711404022 = messageFormatterFn((function(  ) {
  return function(d) { return "People also searched"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a1969523391 = messageFormatterFn((function(  ) {
  return function(d) { return "Explore trending destinations"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b434243883 = messageFormatterFn((function(  ) {
  return function(d) { return "Popular destinations"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b1553873017 = messageFormatterFn((function(  ) {
  return function(d) { return "Trending destinations"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a430771209 = messageFormatterFn((function(  ) {
  return function(d) { return "Current location"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a458497286 = messageFormatterFn((function(  ) {
  return function(d) { return "Location sharing disabled"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a1854913930 = messageFormatterFn((function(  ) {
  return function(d) { return "We are unable to determine your location. Please turn on Location Services on your device so we can determine your location, or type in a destination."; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b911717030 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["en-ZA"], { zero: function() { return number(d["0"]) + " rooms";}, one: function() { return number(d["0"]) + " room";}, two: function() { return number(d["0"]) + " rooms";}, few: function() { return number(d["0"]) + " rooms";}, many: function() { return number(d["0"]) + " rooms";}, other: function() { return number(d["0"]) + " rooms";} }) + ", " + plural(d["1"], 0, pluralFuncs["en-ZA"], { zero: function() { return number(d["1"]) + " travelers";}, one: function() { return number(d["1"]) + " traveller";}, two: function() { return number(d["1"]) + " travellers";}, few: function() { return number(d["1"]) + " travellers";}, many: function() { return number(d["1"]) + " travellers";}, other: function() { return number(d["1"]) + " travellers";} }); }
})(messageFormat.number, messageFormat.plural, {"en-ZA": Globalize("en-ZA").pluralGenerator()}), Globalize("en-ZA").pluralGenerator({}));
Globalize.b62702168 = messageFormatterFn((function(  ) {
  return function(d) { return "The value of the " + d["0"] + " field is now " + d["1"] + ". The value of the " + d["2"] + " field is now " + d["3"] + "."; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b2097295337 = messageFormatterFn((function(  ) {
  return function(d) { return "Swap " + d["0"] + " and " + d["1"] + " fields."; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b1839647300 = messageFormatterFn((function(  ) {
  return function(d) { return "Show password"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a2140977857 = messageFormatterFn((function(  ) {
  return function(d) { return "Hide password"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b1290474694 = messageFormatterFn((function(  ) {
  return function(d) { return "Now showing " + d["0"]; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b1130347749 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " out of " + d["1"]; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b1590822533 = messageFormatterFn((function(  ) {
  return function(d) { return "Image " + d["0"] + " of " + d["1"] + ". " + d["2"]; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b351968072 = messageFormatterFn((function(  ) {
  return function(d) { return "Show next image"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b1547840076 = messageFormatterFn((function(  ) {
  return function(d) { return "Show previous image"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b1160831066 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Show " + plural(d["0"], 0, pluralFuncs["en-ZA"], { zero: function() { return number(d["0"]) + " images";}, one: function() { return number(d["0"]) + " image";}, two: function() { return number(d["0"]) + " images";}, few: function() { return "all " + number(d["0"]) + " images";}, many: function() { return "all " + number(d["0"]) + " images";}, other: function() { return "all " + number(d["0"]) + " images";} }); }
})(messageFormat.number, messageFormat.plural, {"en-ZA": Globalize("en-ZA").pluralGenerator()}), Globalize("en-ZA").pluralGenerator({}));
Globalize.b19473265 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Show " + plural(d["0"], 0, pluralFuncs["en-ZA"], { zero: function() { return number(d["0"]) + " images";}, one: function() { return number(d["0"]) + " image";}, two: function() { return number(d["0"]) + " images";}, few: function() { return "all " + number(d["0"]) + " images";}, many: function() { return "all " + number(d["0"]) + " images";}, other: function() { return "all " + number(d["0"]) + " images";} }) + " for " + d["1"]; }
})(messageFormat.number, messageFormat.plural, {"en-ZA": Globalize("en-ZA").pluralGenerator()}), Globalize("en-ZA").pluralGenerator({}));
Globalize.b1262623540 = messageFormatterFn((function(  ) {
  return function(d) { return "Completed:"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b1417866758 = messageFormatterFn((function(  ) {
  return function(d) { return "Current:"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a973557160 = messageFormatterFn((function(  ) {
  return function(d) { return "Step " + d["0"] + " of " + d["1"]; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b90720908 = messageFormatterFn((function(  ) {
  return function(d) { return "Step " + d["0"] + " of " + d["1"] + ":"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b601454539 = messageFormatterFn((function(  ) {
  return function(d) { return "Image " + d["0"] + " of " + d["1"] + ". " + d["2"]; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a2053528050 = messageFormatterFn((function(  ) {
  return function(d) { return "Next image"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a47029742 = messageFormatterFn((function(  ) {
  return function(d) { return "Previous image"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a438542464 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + ", expand to full screen view"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a1081193748 = messageFormatterFn((function(  ) {
  return function(d) { return "Item " + d["0"] + ", expand to full screen view"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a240386838 = messageFormatterFn((function(  ) {
  return function(d) { return "Current page"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a260921306 = messageFormatterFn((function(  ) {
  return function(d) { return "Show more breadcrumbs"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a223100190 = messageFormatterFn((function(  ) {
  return function(d) { return "Show less breadcrumbs"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a1430687809 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " percent loading"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b1752534148 = messageFormatterFn((function(  ) {
  return function(d) { return "Loading"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b799237452 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + ", " + d["1"]; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b1030151925 = messageFormatterFn((function(  ) {
  return function(d) { return "An error occurred."; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a2095161263 = messageFormatterFn((function(  ) {
  return function(d) { return "Try watching this video on www.youtube.com, or enable Javascript if it is disabled in your browser."; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a153580713 = messageFormatterFn((function(  ) {
  return function(d) { return "Play video"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b284750105 = messageFormatterFn((function(  ) {
  return function(d) { return "Pause video"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a2125442239 = messageFormatterFn((function(  ) {
  return function(d) { return "Video loading"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a1948206261 = messageFormatterFn((function(  ) {
  return function(d) { return "Photosphere"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a1152966225 = messageFormatterFn((function(  ) {
  return function(d) { return "This is a 360 degree image. Use control and arrow keys or command and arrow keys to move around it"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b2130325566 = messageFormatterFn((function(  ) {
  return function(d) { return "Currently displaying: " + d["0"]; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a790429281 = messageFormatterFn((function(  ) {
  return function(d) { return "Moving left. Position: " + d["0"] + " degrees"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b121281576 = messageFormatterFn((function(  ) {
  return function(d) { return "Moving right. Position: " + d["0"] + " degrees"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b1513983051 = messageFormatterFn((function(  ) {
  return function(d) { return "Moving up"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a571131964 = messageFormatterFn((function(  ) {
  return function(d) { return "Moving down"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a687518579 = messageFormatterFn((function(  ) {
  return function(d) { return "You are at the top"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b1947975133 = messageFormatterFn((function(  ) {
  return function(d) { return "You are at the bottom"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b127090313 = messageFormatterFn((function(  ) {
  return function(d) { return "Select all rows"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b929593770 = messageFormatterFn((function(  ) {
  return function(d) { return "Deselect all rows"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b740704410 = messageFormatterFn((function(  ) {
  return function(d) { return "Sort column by descending order"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a469726464 = messageFormatterFn((function(  ) {
  return function(d) { return "Sort column by ascending order"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a2010548432 = messageFormatterFn((function(  ) {
  return function(d) { return "Column is now in descending order"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b80240680 = messageFormatterFn((function(  ) {
  return function(d) { return "Column is now in ascending order"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a1785275696 = messageFormatterFn((function(  ) {
  return function(d) { return "Expand row " + d["0"]; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a654310865 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Showing " + d["0"] + " of " + plural(d["1"], 0, pluralFuncs["en-ZA"], { zero: function() { return number(d["1"]) + " items";}, one: function() { return number(d["1"]) + " item";}, two: function() { return number(d["1"]) + " items";}, few: function() { return number(d["1"]) + " items";}, many: function() { return number(d["1"]) + " items";}, other: function() { return number(d["1"]) + " items";} }); }
})(messageFormat.number, messageFormat.plural, {"en-ZA": Globalize("en-ZA").pluralGenerator()}), Globalize("en-ZA").pluralGenerator({}));
Globalize.b1878679903 = messageFormatterFn((function(  ) {
  return function(d) { return "your current months are " + d["0"] + ", " + d["1"] + " and " + d["2"] + ", " + d["3"] + "."; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b574796471 = messageFormatterFn((function(  ) {
  return function(d) { return "Check-in date cleared."; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b1047040594 = messageFormatterFn((function(  ) {
  return function(d) { return "Check-out date cleared."; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a579818545 = messageFormatterFn((function(  ) {
  return function(d) { return "Dates cleared."; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b1923380721 = messageFormatterFn((function(  ) {
  return function(d) { return "Next"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b1468182193 = messageFormatterFn((function(  ) {
  return function(d) { return "Previous"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a769999120 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " is selected as your check-in date."; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b984666805 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " is selected as your check-out date."; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b1049867220 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " is not a valid check-in date."; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b2060115047 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " is not a valid check-out date."; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a2124970744 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " is unavailable."; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.b1996454999 = messageFormatterFn((function(  ) {
  return function(d) { return "Today"; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a154685654 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " out of " + d["1"]; }
})(), Globalize("en-ZA").pluralGenerator({}));
Globalize.a1717394070 = dateToPartsFormatterFn({"2":Globalize("en-ZA").numberFormatter({"raw":"00"}),"4":Globalize("en-ZA").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy-MM-dd","timeSeparator":":"});
Globalize.a602847702 = dateToPartsFormatterFn({"2":Globalize("en-ZA").numberFormatter({"raw":"00"}),"4":Globalize("en-ZA").numberFormatter({"raw":"0000"})}, {"pattern":"dd/MM/yyyy","timeSeparator":":"});
Globalize.b1654250583 = dateToPartsFormatterFn({"1":Globalize("en-ZA").numberFormatter({"raw":"0"}),"4":Globalize("en-ZA").numberFormatter({"raw":"0000"})}, {"pattern":"d/M/yyyy","timeSeparator":":"});
Globalize.a1518262755 = dateToPartsFormatterFn({"1":Globalize("en-ZA").numberFormatter({"raw":"0"}),"4":Globalize("en-ZA").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy/M/d","timeSeparator":":"});
Globalize.a656988726 = dateToPartsFormatterFn({"2":Globalize("en-ZA").numberFormatter({"raw":"00"}),"4":Globalize("en-ZA").numberFormatter({"raw":"0000"})}, {"pattern":"dd.MM.yyyy","timeSeparator":":"});
Globalize.a1094419883 = dateToPartsFormatterFn({"1":Globalize("en-ZA").numberFormatter({"raw":"0"}),"4":Globalize("en-ZA").numberFormatter({"raw":"0000"})}, {"pattern":"d.M.yyyy","timeSeparator":":"});
Globalize.b1840256554 = dateToPartsFormatterFn({"2":Globalize("en-ZA").numberFormatter({"raw":"00"}),"4":Globalize("en-ZA").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy/MM/dd","timeSeparator":":"});
Globalize.a711129750 = dateToPartsFormatterFn({"2":Globalize("en-ZA").numberFormatter({"raw":"00"}),"4":Globalize("en-ZA").numberFormatter({"raw":"0000"})}, {"pattern":"dd-MM-yyyy","timeSeparator":":"});
Globalize.a1240624022 = dateToPartsFormatterFn({"2":Globalize("en-ZA").numberFormatter({"raw":"00"}),"4":Globalize("en-ZA").numberFormatter({"raw":"0000"})}, {"pattern":"MM/dd/yyyy","timeSeparator":":"});
Globalize.b1895821975 = dateToPartsFormatterFn({"1":Globalize("en-ZA").numberFormatter({"raw":"0"}),"4":Globalize("en-ZA").numberFormatter({"raw":"0000"})}, {"pattern":"M/d/yyyy","timeSeparator":":"});
Globalize.b61431242 = dateToPartsFormatterFn({"2":Globalize("en-ZA").numberFormatter({"raw":"00"}),"4":Globalize("en-ZA").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy.MM.dd","timeSeparator":":"});
Globalize.a1985875977 = dateToPartsFormatterFn({}, {"pattern":"EEEEE","timeSeparator":":","days":{"E":{"5":{"sun":"S","mon":"M","tue":"T","wed":"W","thu":"T","fri":"F","sat":"S"}}}});
Globalize.b351612330 = dateToPartsFormatterFn({}, {"pattern":"EEEE","timeSeparator":":","days":{"E":{"4":{"sun":"Sunday","mon":"Monday","tue":"Tuesday","wed":"Wednesday","thu":"Thursday","fri":"Friday","sat":"Saturday"}}}});
Globalize.b1604857770 = dateToPartsFormatterFn({}, {"pattern":"MMMM","timeSeparator":":","months":{"M":{"4":{"1":"January","2":"February","3":"March","4":"April","5":"May","6":"June","7":"July","8":"August","9":"September","10":"October","11":"November","12":"December"}}}});
Globalize.a572081226 = dateToPartsFormatterFn({"1":Globalize("en-ZA").numberFormatter({"raw":"0"})}, {"pattern":"d","timeSeparator":":"});
Globalize.a1334255177 = dateToPartsFormatterFn({"1":Globalize("en-ZA").numberFormatter({"raw":"0"}),"2":Globalize("en-ZA").numberFormatter({"raw":"00"})}, {"pattern":"M/d/yy","timeSeparator":":"});
Globalize.a184469464 = dateToPartsFormatterFn({"2":Globalize("en-ZA").numberFormatter({"raw":"00"})}, {"pattern":"dd MMM","timeSeparator":":","months":{"M":{"3":{"1":"Jan","2":"Feb","3":"Mar","4":"Apr","5":"May","6":"Jun","7":"Jul","8":"Aug","9":"Sep","10":"Oct","11":"Nov","12":"Dec"}}}});
Globalize.a1404224945 = dateToPartsFormatterFn({"1":Globalize("en-ZA").numberFormatter({"raw":"0"})}, {"pattern":"d MMMM","timeSeparator":":","months":{"M":{"4":{"1":"January","2":"February","3":"March","4":"April","5":"May","6":"June","7":"July","8":"August","9":"September","10":"October","11":"November","12":"December"}}}});
Globalize.b1656645852 = dateToPartsFormatterFn({"1":Globalize("en-ZA").numberFormatter({"raw":"0"}),"2":Globalize("en-ZA").numberFormatter({"raw":"00"})}, {"pattern":"dd MMMM y","timeSeparator":":","months":{"M":{"4":{"1":"January","2":"February","3":"March","4":"April","5":"May","6":"June","7":"July","8":"August","9":"September","10":"October","11":"November","12":"December"}}}});
Globalize.a777783164 = dateToPartsFormatterFn({"1":Globalize("en-ZA").numberFormatter({"raw":"0"})}, {"pattern":"MMMM y","timeSeparator":":","months":{"M":{"4":{"1":"January","2":"February","3":"March","4":"April","5":"May","6":"June","7":"July","8":"August","9":"September","10":"October","11":"November","12":"December"}}}});
Globalize.a778468357 = dateToPartsFormatterFn({"1":Globalize("en-ZA").numberFormatter({"raw":"0"}),"2":Globalize("en-ZA").numberFormatter({"raw":"00"})}, {"pattern":"dd MMM y","timeSeparator":":","months":{"M":{"3":{"1":"Jan","2":"Feb","3":"Mar","4":"Apr","5":"May","6":"Jun","7":"Jul","8":"Aug","9":"Sep","10":"Oct","11":"Nov","12":"Dec"}}}});
Globalize.b1565969384 = dateToPartsFormatterFn({"2":Globalize("en-ZA").numberFormatter({"raw":"00"})}, {"pattern":"EEEE, dd MMM","timeSeparator":":","days":{"E":{"4":{"sun":"Sunday","mon":"Monday","tue":"Tuesday","wed":"Wednesday","thu":"Thursday","fri":"Friday","sat":"Saturday"}}},"months":{"M":{"3":{"1":"Jan","2":"Feb","3":"Mar","4":"Apr","5":"May","6":"Jun","7":"Jul","8":"Aug","9":"Sep","10":"Oct","11":"Nov","12":"Dec"}}}});
Globalize.a1396836777 = dateToPartsFormatterFn({"2":Globalize("en-ZA").numberFormatter({"raw":"00"})}, {"pattern":"E, dd MMM","timeSeparator":":","days":{"E":{"1":{"sun":"Sun","mon":"Mon","tue":"Tue","wed":"Wed","thu":"Thu","fri":"Fri","sat":"Sat"}}},"months":{"M":{"3":{"1":"Jan","2":"Feb","3":"Mar","4":"Apr","5":"May","6":"Jun","7":"Jul","8":"Aug","9":"Sep","10":"Oct","11":"Nov","12":"Dec"}}}});
Globalize.a2096107821 = dateFormatterFn(Globalize("en-ZA").dateToPartsFormatter({"raw":"yyyy-MM-dd"}));
Globalize.a981561453 = dateFormatterFn(Globalize("en-ZA").dateToPartsFormatter({"raw":"dd/MM/yyyy"}));
Globalize.a160666624 = dateFormatterFn(Globalize("en-ZA").dateToPartsFormatter({"raw":"d/M/yyyy"}));
Globalize.b961787334 = dateFormatterFn(Globalize("en-ZA").dateToPartsFormatter({"raw":"yyyy/M/d"}));
Globalize.a1035702477 = dateFormatterFn(Globalize("en-ZA").dateToPartsFormatter({"raw":"dd.MM.yyyy"}));
Globalize.b1385630206 = dateFormatterFn(Globalize("en-ZA").dateToPartsFormatter({"raw":"d.M.yyyy"}));
Globalize.b1461542803 = dateFormatterFn(Globalize("en-ZA").dateToPartsFormatter({"raw":"yyyy/MM/dd"}));
Globalize.a1089843501 = dateFormatterFn(Globalize("en-ZA").dateToPartsFormatter({"raw":"dd-MM-yyyy"}));
Globalize.a1619337773 = dateFormatterFn(Globalize("en-ZA").dateToPartsFormatter({"raw":"MM/dd/yyyy"}));
Globalize.b80904768 = dateFormatterFn(Globalize("en-ZA").dateToPartsFormatter({"raw":"M/d/yyyy"}));
Globalize.a317282509 = dateFormatterFn(Globalize("en-ZA").dateToPartsFormatter({"raw":"yyyy.MM.dd"}));
Globalize.a1834702610 = dateFormatterFn(Globalize("en-ZA").dateToPartsFormatter({"raw":"EEEEE"}));
Globalize.b1187772883 = dateFormatterFn(Globalize("en-ZA").dateToPartsFormatter({"raw":"EEEE"}));
Globalize.a1853948973 = dateFormatterFn(Globalize("en-ZA").dateToPartsFormatter({"raw":"MMMM"}));
Globalize.a1155364819 = dateFormatterFn(Globalize("en-ZA").dateToPartsFormatter({"raw":"d"}));
Globalize.a942848096 = dateFormatterFn(Globalize("en-ZA").dateToPartsFormatter({"raw":"M/d/yy"}));
Globalize.a612328033 = dateFormatterFn(Globalize("en-ZA").dateToPartsFormatter({"skeleton":"MMMd"}));
Globalize.a1782938696 = dateFormatterFn(Globalize("en-ZA").dateToPartsFormatter({"skeleton":"MMMMd"}));
Globalize.a1493545837 = dateFormatterFn(Globalize("en-ZA").dateToPartsFormatter({"skeleton":"yMMMMd"}));
Globalize.a1156496915 = dateFormatterFn(Globalize("en-ZA").dateToPartsFormatter({"skeleton":"yMMMM"}));
Globalize.a1157182108 = dateFormatterFn(Globalize("en-ZA").dateToPartsFormatter({"skeleton":"yMMMd"}));
Globalize.a2111267361 = dateFormatterFn(Globalize("en-ZA").dateToPartsFormatter({"skeleton":"MMMEEEEd"}));
Globalize.a1775550528 = dateFormatterFn(Globalize("en-ZA").dateToPartsFormatter({"skeleton":"MMMEd"}));
Globalize.b584797732 = dateParserFn(Globalize("en-ZA").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"yyyy-MM-dd","digitsRe":/\d/});
Globalize.b1699344100 = dateParserFn(Globalize("en-ZA").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"dd/MM/yyyy","digitsRe":/\d/});
Globalize.b628714385 = dateParserFn(Globalize("en-ZA").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d/M/yyyy","digitsRe":/\d/});
Globalize.b1751168343 = dateParserFn(Globalize("en-ZA").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"yyyy/M/d","digitsRe":/\d/});
Globalize.b1645203076 = dateParserFn(Globalize("en-ZA").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"dd.MM.yyyy","digitsRe":/\d/});
Globalize.a2119956081 = dateParserFn(Globalize("en-ZA").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d.M.yyyy","digitsRe":/\d/});
Globalize.a152518940 = dateParserFn(Globalize("en-ZA").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"yyyy/MM/dd","digitsRe":/\d/});
Globalize.b1591062052 = dateParserFn(Globalize("en-ZA").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"dd-MM-yyyy","digitsRe":/\d/});
Globalize.b1061567780 = dateParserFn(Globalize("en-ZA").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"MM/dd/yyyy","digitsRe":/\d/});
Globalize.b870285777 = dateParserFn(Globalize("en-ZA").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"M/d/yyyy","digitsRe":/\d/});
Globalize.a1931344252 = dateParserFn(Globalize("en-ZA").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"yyyy.MM.dd","digitsRe":/\d/});
Globalize.b654129917 = dateParserFn(Globalize("en-ZA").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"EEEEE","digitsRe":/\d/,"gregorian/days/format/narrow":[["sun",/^S/],["mon",/^M/],["tue",/^T/],["wed",/^W/],["thu",/^T/],["fri",/^F/],["sat",/^S/]]});
Globalize.b2099341796 = dateParserFn(Globalize("en-ZA").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"EEEE","digitsRe":/\d/,"gregorian/days/format/wide":[["wed",/^Wednesday/],["thu",/^Thursday/],["sat",/^Saturday/],["tue",/^Tuesday/],["sun",/^Sunday/],["mon",/^Monday/],["fri",/^Friday/]]});
Globalize.a942380060 = dateParserFn(Globalize("en-ZA").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"MMMM","digitsRe":/\d/,"gregorian/months/format/wide":[["9",/^September/],["2",/^February/],["11",/^November/],["12",/^December/],["1",/^January/],["10",/^October/],["8",/^August/],["3",/^March/],["4",/^April/],["6",/^June/],["7",/^July/],["5",/^May/]]});
Globalize.b402422204 = dateParserFn(Globalize("en-ZA").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d","digitsRe":/\d/});
Globalize.a1098451087 = dateParserFn(Globalize("en-ZA").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"M/d/yy","digitsRe":/\d/});
Globalize.a1911320530 = dateParserFn(Globalize("en-ZA").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"dd MMM","digitsRe":/\d/,"gregorian/months/format/abbreviated":[["1",/^Jan/],["2",/^Feb/],["3",/^Mar/],["4",/^Apr/],["5",/^May/],["6",/^Jun/],["7",/^Jul/],["8",/^Aug/],["9",/^Sep/],["10",/^Oct/],["11",/^Nov/],["12",/^Dec/]]});
Globalize.b897966857 = dateParserFn(Globalize("en-ZA").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d MMMM","digitsRe":/\d/,"gregorian/months/format/wide":[["9",/^September/],["2",/^February/],["11",/^November/],["12",/^December/],["1",/^January/],["10",/^October/],["8",/^August/],["3",/^March/],["4",/^April/],["6",/^June/],["7",/^July/],["5",/^May/]]});
Globalize.b10147682 = dateParserFn(Globalize("en-ZA").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"dd MMMM y","digitsRe":/\d/,"gregorian/months/format/wide":[["9",/^September/],["2",/^February/],["11",/^November/],["12",/^December/],["1",/^January/],["10",/^October/],["8",/^August/],["3",/^March/],["4",/^April/],["6",/^June/],["7",/^July/],["5",/^May/]]});
Globalize.b1524408638 = dateParserFn(Globalize("en-ZA").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"MMMM y","digitsRe":/\d/,"gregorian/months/format/wide":[["9",/^September/],["2",/^February/],["11",/^November/],["12",/^December/],["1",/^January/],["10",/^October/],["8",/^August/],["3",/^March/],["4",/^April/],["6",/^June/],["7",/^July/],["5",/^May/]]});
Globalize.b1523723445 = dateParserFn(Globalize("en-ZA").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"dd MMM y","digitsRe":/\d/,"gregorian/months/format/abbreviated":[["1",/^Jan/],["2",/^Feb/],["3",/^Mar/],["4",/^Apr/],["5",/^May/],["6",/^Jun/],["7",/^Jul/],["8",/^Aug/],["9",/^Sep/],["10",/^Oct/],["11",/^Nov/],["12",/^Dec/]]});
Globalize.a170807058 = dateParserFn(Globalize("en-ZA").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"EEEE, dd MMM","digitsRe":/\d/,"gregorian/days/format/wide":[["wed",/^Wednesday/],["thu",/^Thursday/],["sat",/^Saturday/],["tue",/^Tuesday/],["sun",/^Sunday/],["mon",/^Monday/],["fri",/^Friday/]],"gregorian/months/format/abbreviated":[["1",/^Jan/],["2",/^Feb/],["3",/^Mar/],["4",/^Apr/],["5",/^May/],["6",/^Jun/],["7",/^Jul/],["8",/^Aug/],["9",/^Sep/],["10",/^Oct/],["11",/^Nov/],["12",/^Dec/]]});
Globalize.b905355025 = dateParserFn(Globalize("en-ZA").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"E, dd MMM","digitsRe":/\d/,"gregorian/days/format/abbreviated":[["sun",/^Sun/],["mon",/^Mon/],["tue",/^Tue/],["wed",/^Wed/],["thu",/^Thu/],["fri",/^Fri/],["sat",/^Sat/]],"gregorian/months/format/abbreviated":[["1",/^Jan/],["2",/^Feb/],["3",/^Mar/],["4",/^Apr/],["5",/^May/],["6",/^Jun/],["7",/^Jul/],["8",/^Aug/],["9",/^Sep/],["10",/^Oct/],["11",/^Nov/],["12",/^Dec/]]});
module.exports = Globalize;
